import { Link } from "@/components/common/Link";
const portraits = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_12.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_13.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_14.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_15.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_16.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_10.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_11.png"];
const radiusMap: Record<number, string> = {
  0: "0 0 1rem 0",
  1: "0 0 0 1rem",
  2: "1rem 0 0 0",
  3: "0 1rem 0 0"
};
export default function AboutAssembliesOfGod() {
  return <section style={{
    backgroundColor: "#F5F4F2",
    width: "100%",
    overflow: "hidden",
    paddingTop: "60px",
    paddingBottom: "60px",
    position: "relative"
  }}>
      <style>{`
        @import url('https://api.fontshare.com/v2/css?f[]=switzer@400,500,600,700&display=swap');

        .marquee-track {
          display: flex;
          animation: marquee-scroll 28s linear infinite;
          width: max-content;
        }

        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(calc(-160px * 7 - 7 * 16px)); }
        }

        @media (min-width: 768px) {
          @keyframes marquee-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(calc(-200px * 7 - 7 * 24px)); }
          }
        }

        .marquee-container {
          display: flex;
          overflow: hidden;
          mask-image: linear-gradient(to right, rgba(0,0,0,0), rgb(0,0,0) 10%, rgb(0,0,0) 90%, rgba(0,0,0,0));
          -webkit-mask-image: linear-gradient(to right, rgba(0,0,0,0), rgb(0,0,0) 10%, rgb(0,0,0) 90%, rgba(0,0,0,0));
          width: 100%;
        }

        .learn-more-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: rgb(255, 255, 255);
          font-family: 'Switzer', sans-serif;
          font-size: 14px;
          font-weight: 500;
          line-height: 21px;
          background-color: rgb(53, 53, 51);
          border-radius: 28px;
          border: 1px solid rgb(53, 53, 51);
          padding: 4px 4px 4px 12px;
          text-transform: uppercase;
          text-align: center;
          text-decoration: none;
          cursor: pointer;
          transition: background-color 0.15s ease, border-color 0.15s ease;
        }

        .learn-more-btn:hover {
          background-color: #F73C4A;
          border-color: #F73C4A;
          color: #fff;
        }

        .learn-more-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          background-color: #fff;
          border-radius: 50%;
          flex-shrink: 0;
        }
      `}</style>

      {/* Marquee de imágenes adaptado para móviles y PC */}
      <div className="marquee-container" style={{
      marginBottom: "32px"
    }}>
        <div className="marquee-track">
          {[...portraits, ...portraits, ...portraits].map((src, i) => {
          const idx = i % 4;
          const radius = radiusMap[idx];
          return <img key={i} data-index={i} src={src} alt="" style={{
            width: "160px",
            height: "160px",
            objectFit: "cover",
            borderRadius: radius,
            marginRight: "16px",
            flexShrink: 0
          }} className="md:w-[200px] md:h-[200px] md:mr-[24px]" />;
        })}
        </div>
      </div>

      {/* Contenedor de texto y botón con auto-altura */}
      <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      paddingLeft: "20px",
      paddingRight: "20px"
    }}>
        <h1 style={{
        color: "rgb(33, 33, 31)",
        fontFamily: "Switzer, sans-serif",
        fontSize: "48px",
        fontWeight: "400",
        lineHeight: "42px",
        textTransform: "uppercase",
        textAlign: "center",
        marginBottom: "20px",
        letterSpacing: "0.02em"
      }} className="md:text-[48px] md:leading-[52.8px] md:mb-[32px]">
          Las Asambleas de Dios
        </h1>

        <p style={{
        color: "rgb(33, 33, 31)",
        fontFamily: "Switzer, sans-serif",
        fontSize: "16px",
        fontWeight: "300",
        lineHeight: "24px",
        textAlign: "center",
        marginBottom: "28px"
      }} className="w-full max-w-[700px] md:text-[20px] md:leading-[28px] md:mb-[32px]">
          En las Asambleas de Dios, nuestra misión es evangelizar a los perdidos, adorar a Dios, Discipular a los creyentes y mostrar compasión a los demás. Estamos anclados en nuestro compromiso de involucrarnos activamente con la Biblia, vivir una vida empoderada por el Espíritu y compartir el evangelio a través de misiones, tanto nacional como internacionalmente
        </p>

        <Link to="#" className="learn-more-btn">
          MÁS INFORMACIÓN
          <span className="learn-more-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgb(53,53,51)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="7" y1="17" x2="17" y2="7" />
              <polyline points="7 7 17 7 17 17" />
            </svg>
          </span>
        </Link>
      </div>
    </section>;
}